export const EDIT_CASH_BOX = 'EDIT_CASH_BOX';
export const CREATE_CASH_BOX = 'CREATE_CASH_BOX';
export const CREATE_OPERATION = 'CREATE_OPERATION';
export const LIST_CASH_BOXES = 'LIST_CASH_BOXES';
export const LIST_CASH_BOX_OPERATIONS_BY_ID = 'LIST_CASH_BOX_OPERATIONS_BY_ID'
export const CASH_BOX_OPERATIONS_TABLE_LENGTH = 'CASH_BOX_OPERATIONS_TABLE_LENGTH'
export const GET_LOGGED_CASH_BOX = 'GET_LOGGED_CASH_BOX'